module.exports = __webpack_public_path__ + "static/img/ump.e6c2ccb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/ump.png
// module id = BdzC
// module chunks = 0